const light = {
  '--text': 'var(--color-text-subtle)',
  '--text-hover': 'var(--color-grey-1000)',
  '--text-active': 'var(--color-grey-1000)',
  '--text-selected': 'var(--color-primary-800)',
  '--text-selected-hover': 'var(--color-primary-800)',
  '--text-selected-pressed': 'var(--color-primary-800)',
  '--text-selected-focus': 'var(--color-primary-800)',
  '--background': 'white',
  '--background-hover': 'var(--color-grey-100)',
  '--background-active': 'var(--color-grey-200)',
  '--background-selected': 'var(--color-primary-100)',
  '--background-selected-hover': 'var(--color-grey-100)',
  '--background-selected-pressed': 'var(--color-grey-200)',
  '--item-text-selected': 'var(--color-grey-900)',
  '--item-background-selected': 'var(--color-grey-900)',
  '--trigger-background-open': 'var(--color-grey-200)',
  '--dropdown-background': 'white'
}

export const colorSchemes = {
  light
}
